import { createFileRoute } from '@tanstack/react-router'
import { roleQueryOptions } from '../../../features/admin/queries'
import { RolePage } from '../../../features/admin/role-pages'

export const Route = createFileRoute('/_app/roles/$roleId')({
  staticData: { crumb: 'role' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(roleQueryOptions(params.roleId)),
  component: RolePage,
})
